(() => {
  const showImages = (scope) => {
    scope.querySelectorAll('img[data-ck-src]').forEach((img) => {
      img.srcset = img.dataset.ckSrcset;
      img.src = img.dataset.ckSrc;
      img.removeAttribute('data-ck-src');
    });
  };

  const showGroup = (item, name) => {
    let shown = null;
    item.querySelectorAll('[data-ck-pp-group]').forEach((group) => {
      const match = group.dataset.ckPpGroup === name;
      group.hidden = !match;
      if (match) shown = group;
    });
    if (shown) showImages(shown);
    const all = item.querySelector('[data-ck-pp-all]');
    if (all && shown) {
      all.href = name === 'default' ? all.dataset.defaultUrl : shown.dataset.ckPpUrl;
      all.querySelector('[data-ck-pp-all-label]').textContent = shown.dataset.ckPpLabel;
    }
    item.querySelectorAll('[data-ck-pp-target]').forEach((link) => {
      link.classList.toggle('is-active', link.dataset.ckPpTarget === name);
    });
  };

  document.querySelectorAll('.ck-pp-item').forEach((item) => {
    item.addEventListener('mouseenter', () => showGroup(item, 'default'));
    item.addEventListener('focusin', () => showImages(item.querySelector('[data-ck-pp-group]:not([hidden])')));

    item.querySelectorAll('[data-ck-pp-target]').forEach((link) => {
      const select = () => showGroup(item, link.dataset.ckPpTarget);
      link.addEventListener('mouseenter', select);
      link.addEventListener('focus', select);
    });
  });
})();
